document.addEventListener('DOMContentLoaded', function () {
  initSizeSystemPickers();
});

function initSizeSystemPickers() {
  document.querySelectorAll('[data-size-system-picker]').forEach(picker => {
    const tabs = picker.querySelectorAll('[data-system]');
    const swatches = picker.querySelectorAll('[data-value]');

    // Tab 切换
    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const system = this.dataset.system.toLowerCase();

        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');

        swatches.forEach(swatch => {
          const label = swatch.querySelector('.size-system-picker__swatch-label');
          label.textContent = swatch.dataset[system] || swatch.dataset.uk;
        });
      });
    });

    // 尺码选择
    swatches.forEach(swatch => {
      swatch.addEventListener('click', function () {
        if (this.getAttribute('aria-disabled') === 'true') return;

        swatches.forEach(s => s.classList.remove('is-active'));
        this.classList.add('is-active');

        const variantValue = this.dataset.value;

        const variants = window.productVariants || [];
        const matched = variants.find(v =>
          v.option1 === variantValue ||
          v.option2 === variantValue ||
          v.option3 === variantValue
        );

        if (!matched) {
          console.warn('No variant matched for:', variantValue);
          return;
        }

        // 更新表单变体ID
        const variantPickerEl = picker.closest('variant-picker');
        const formId = variantPickerEl?.getAttribute('form-id');
        const idInput = document.querySelector(`form#${CSS.escape(formId)} input[name="id"]`);
        if (idInput) {
          idInput.value = matched.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // 更新 URL
        const url = new URL(window.location);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url);

        // 更新 SKU 显示
        const skuEl = document.querySelector('[data-variant-sku]');
        if (skuEl) skuEl.textContent = matched.sku || '';
      });
    }); // swatches forEach 结束

  }); // picker forEach 结束

} // initSizeSystemPickers 结束
